import { SmsTemplatesGridView } from '~/components/system/sms-templates';
import { PageContainer } from '~/components/page-container';

export function SmsTemplates() {
	return (
		<PageContainer>
			<SmsTemplatesGridView />
		</PageContainer>
	);
}
